// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { SigningKeyOperationsListSigningKeysData, SigningKeyOperationsListSigningKeysResponses, SigningKeyOperationsListSigningKeysErrors, SigningKeyOperationsCreateSigningKeyData, SigningKeyOperationsCreateSigningKeyResponses, SigningKeyOperationsCreateSigningKeyErrors, SigningKeyOperationsDeleteSigningKeyData, SigningKeyOperationsDeleteSigningKeyResponses, SigningKeyOperationsDeleteSigningKeyErrors, AuthOperationsMintTokenData, AuthOperationsMintTokenResponses, AuthOperationsMintTokenErrors, AuthOperationsRefreshTokenData, AuthOperationsRefreshTokenResponses, AuthOperationsRefreshTokenErrors, AuthOperationsRevokeTokenData, AuthOperationsRevokeTokenResponses, AuthOperationsRevokeTokenErrors, AuthOperationsRevokeAllTokensData, AuthOperationsRevokeAllTokensResponses, AuthOperationsRevokeAllTokensErrors, LeaderboardOperationsGetLeaderboardData, LeaderboardOperationsGetLeaderboardResponses, LeaderboardOperationsGetLeaderboardErrors, LeaderboardOperationsGetFocusedLeaderboardDataData, LeaderboardOperationsGetFocusedLeaderboardDataResponses, LeaderboardOperationsGetFocusedLeaderboardDataErrors, RewardOperationsGetRewardsData, RewardOperationsGetRewardsResponses, RewardOperationsGetRewardsErrors, RewardOperationsGetQuestsData, RewardOperationsGetQuestsResponses, RewardOperationsGetQuestsErrors, RewardOperationsRedeemRewardData, RewardOperationsRedeemRewardResponses, RewardOperationsRedeemRewardErrors, RewardOperationsUpdateRewardData, RewardOperationsUpdateRewardResponses, RewardOperationsUpdateRewardErrors, UserOperationsGetAvailableUsersData, UserOperationsGetAvailableUsersResponses, UserOperationsGetAvailableUsersErrors, UserOperationsGetCustomersByIdsData, UserOperationsGetCustomersByIdsResponses, UserOperationsGetCustomersByIdsErrors, UserOperationsGetCurrentUserData, UserOperationsGetCurrentUserResponses, UserOperationsGetCurrentUserErrors, UserOperationsUpdatePointsData, UserOperationsUpdatePointsResponses, UserOperationsUpdatePointsErrors, UserOperationsSwitchCurrentUserData, UserOperationsSwitchCurrentUserResponses, UserOperationsSwitchCurrentUserErrors, ApiKeyOperationsListApiKeysData, ApiKeyOperationsListApiKeysResponses, ApiKeyOperationsListApiKeysErrors, ApiKeyOperationsCreateApiKeyData, ApiKeyOperationsCreateApiKeyResponses, ApiKeyOperationsCreateApiKeyErrors, ApiKeyOperationsRevokeApiKeyData, ApiKeyOperationsRevokeApiKeyResponses, ApiKeyOperationsRevokeApiKeyErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List all signing keys for an account (without private keys)
 */
export const signingKeyOperationsListSigningKeys = <ThrowOnError extends boolean = false>(options: Options<SigningKeyOperationsListSigningKeysData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SigningKeyOperationsListSigningKeysResponses, SigningKeyOperationsListSigningKeysErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/accounts/{account_id}/signing-keys',
        ...options
    });
};

/**
 * Generate new RSA signing key pair for JWT signing
 */
export const signingKeyOperationsCreateSigningKey = <ThrowOnError extends boolean = false>(options: Options<SigningKeyOperationsCreateSigningKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SigningKeyOperationsCreateSigningKeyResponses, SigningKeyOperationsCreateSigningKeyErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/accounts/{account_id}/signing-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a signing key (ensuring at least one remains)
 */
export const signingKeyOperationsDeleteSigningKey = <ThrowOnError extends boolean = false>(options: Options<SigningKeyOperationsDeleteSigningKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<SigningKeyOperationsDeleteSigningKeyResponses, SigningKeyOperationsDeleteSigningKeyErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/accounts/{account_id}/signing-keys/{key_id}',
        ...options
    });
};

/**
 * Create JWT access and refresh tokens for a customer
 */
export const authOperationsMintToken = <ThrowOnError extends boolean = false>(options: Options<AuthOperationsMintTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthOperationsMintTokenResponses, AuthOperationsMintTokenErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/auth/tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh JWT access token using refresh token
 */
export const authOperationsRefreshToken = <ThrowOnError extends boolean = false>(options: Options<AuthOperationsRefreshTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthOperationsRefreshTokenResponses, AuthOperationsRefreshTokenErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/auth/tokens/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Immediately blacklist a specific JWT token
 */
export const authOperationsRevokeToken = <ThrowOnError extends boolean = false>(options: Options<AuthOperationsRevokeTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthOperationsRevokeTokenResponses, AuthOperationsRevokeTokenErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/tokens/revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Revoke all tokens for a customer
 */
export const authOperationsRevokeAllTokens = <ThrowOnError extends boolean = false>(options: Options<AuthOperationsRevokeAllTokensData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthOperationsRevokeAllTokensResponses, AuthOperationsRevokeAllTokensErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/auth/tokens/revoke-all',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the global leaderboard
 */
export const leaderboardOperationsGetLeaderboard = <ThrowOnError extends boolean = false>(options?: Options<LeaderboardOperationsGetLeaderboardData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LeaderboardOperationsGetLeaderboardResponses, LeaderboardOperationsGetLeaderboardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/leaderboard',
        ...options
    });
};

/**
 * Get focused leaderboard view for a specific user
 */
export const leaderboardOperationsGetFocusedLeaderboardData = <ThrowOnError extends boolean = false>(options: Options<LeaderboardOperationsGetFocusedLeaderboardDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LeaderboardOperationsGetFocusedLeaderboardDataResponses, LeaderboardOperationsGetFocusedLeaderboardDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/leaderboard/focused/{customer_id}',
        ...options
    });
};

/**
 * Get all available rewards
 */
export const rewardOperationsGetRewards = <ThrowOnError extends boolean = false>(options?: Options<RewardOperationsGetRewardsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RewardOperationsGetRewardsResponses, RewardOperationsGetRewardsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rewards',
        ...options
    });
};

/**
 * Get quest-type rewards
 */
export const rewardOperationsGetQuests = <ThrowOnError extends boolean = false>(options?: Options<RewardOperationsGetQuestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RewardOperationsGetQuestsResponses, RewardOperationsGetQuestsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rewards/quests',
        ...options
    });
};

/**
 * Redeem a reward with points
 */
export const rewardOperationsRedeemReward = <ThrowOnError extends boolean = false>(options: Options<RewardOperationsRedeemRewardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RewardOperationsRedeemRewardResponses, RewardOperationsRedeemRewardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rewards/redeem',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update reward information
 */
export const rewardOperationsUpdateReward = <ThrowOnError extends boolean = false>(options: Options<RewardOperationsUpdateRewardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<RewardOperationsUpdateRewardResponses, RewardOperationsUpdateRewardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rewards/{reward_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get list of available users for user switching
 */
export const userOperationsGetAvailableUsers = <ThrowOnError extends boolean = false>(options?: Options<UserOperationsGetAvailableUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserOperationsGetAvailableUsersResponses, UserOperationsGetAvailableUsersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/available',
        ...options
    });
};

/**
 * Get customers by their IDs
 */
export const userOperationsGetCustomersByIds = <ThrowOnError extends boolean = false>(options: Options<UserOperationsGetCustomersByIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserOperationsGetCustomersByIdsResponses, UserOperationsGetCustomersByIdsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/batch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the currently authenticated user
 */
export const userOperationsGetCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<UserOperationsGetCurrentUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserOperationsGetCurrentUserResponses, UserOperationsGetCurrentUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/current',
        ...options
    });
};

/**
 * Update customer points
 */
export const userOperationsUpdatePoints = <ThrowOnError extends boolean = false>(options: Options<UserOperationsUpdatePointsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UserOperationsUpdatePointsResponses, UserOperationsUpdatePointsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/points',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Switch to a different user
 */
export const userOperationsSwitchCurrentUser = <ThrowOnError extends boolean = false>(options: Options<UserOperationsSwitchCurrentUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UserOperationsSwitchCurrentUserResponses, UserOperationsSwitchCurrentUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/users/switch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all API keys for a workspace (without exposing secrets)
 */
export const apiKeyOperationsListApiKeys = <ThrowOnError extends boolean = false>(options: Options<ApiKeyOperationsListApiKeysData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ApiKeyOperationsListApiKeysResponses, ApiKeyOperationsListApiKeysErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/workspaces/{workspace_id}/api-keys',
        ...options
    });
};

/**
 * Create a new API key with specified scopes
 */
export const apiKeyOperationsCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<ApiKeyOperationsCreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApiKeyOperationsCreateApiKeyResponses, ApiKeyOperationsCreateApiKeyErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/workspaces/{workspace_id}/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Revoke an API key immediately
 */
export const apiKeyOperationsRevokeApiKey = <ThrowOnError extends boolean = false>(options: Options<ApiKeyOperationsRevokeApiKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ApiKeyOperationsRevokeApiKeyResponses, ApiKeyOperationsRevokeApiKeyErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/workspaces/{workspace_id}/api-keys/{key_id}',
        ...options
    });
};